var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { KosekiRemarkService } from "~/services/repair-service/koseki-remark.service";
import AddRemark from "~/components/data-repair/census-remark/add-remark.vue";
import EditRemark from "~/components/data-repair/census-remark/edit-remark.vue";
import CensusRemarkDetail from "~/components/data-repair/census-remark/census-remark-detail.vue";
import ImportBatchDeletion from "~/components/data-repair/census-data/import-batch-deletion.vue";
import { DataRepairImportService } from "~/services/repair-service/data-repair-import.service";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import RepairDataImport from "~/components/data-repair/repair-data-import.vue";
import { dataRepair } from "~/config/enum.config";
//@Auth(105)
var CensusRemark = /** @class */ (function (_super) {
    __extends(CensusRemark, _super);
    function CensusRemark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowData = {};
        _this.loading = {
            state: false
        };
        _this.importType = "HOUSEHOLD_REGISTER_REMARK"; //户籍备注
        _this.censusModel = {};
        _this.editModel = {};
        _this.dataSet = [];
        _this.typeSet = [];
        _this.currentType = dataRepair;
        _this.kosekiModel = {
            name: "",
            idNo: "",
            bank: "",
            type: "",
            applyTransferArea: "",
            remark: "",
            importType: "",
            applyFileContent: ""
        };
        _this.data = {};
        _this.dialog = {
            detail: false,
            edit: false,
            import: false,
            deletion: false
        };
        return _this;
    }
    CensusRemark.prototype.created = function () { };
    CensusRemark.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * keep-alive生命周期钩子函数
     */
    CensusRemark.prototype.activated = function () {
        // 加载数据
        this.refreshData();
    };
    /**
     * 查询户籍备注
     */
    CensusRemark.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.kosekiRemarkService
            .search(this.kosekiModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
        this.getDataType();
    };
    //添加户籍弹窗
    CensusRemark.prototype.addClick = function () {
        this.dialog.detail = true;
    };
    CensusRemark.prototype.dataImpClick = function () {
        this.dialog.import = true;
    };
    /**
     * 获取下载模板
     */
    CensusRemark.prototype.downLoadTemplate = function () {
        var _this = this;
        this.kosekiModel.applyFileContent = this.importType;
        this.dataRepairImportService
            .getSystemTemplate(this.kosekiModel, this.loading)
            .subscribe(function (data) {
            if (data) {
                _this.uploadFileService
                    .getFileStreamById(data.value)
                    .subscribe(function () { return _this.$message.success("下载成功"); });
            }
        }, function (_a) {
            var msg = _a.msg;
        });
        this.kosekiModel.applyFileContent = null;
    };
    /**
     * 查询类型
     */
    CensusRemark.prototype.getDataType = function () {
        var _this = this;
        this.loading.state = true;
        this.kosekiModel.importType = this.importType;
        this.dataRepairImportService
            .getDataTypes(this.kosekiModel, this.loading)
            .subscribe(function (data) {
            _this.typeSet = data;
        });
        this.kosekiModel.importType = null;
    };
    /**
     * 删除户籍备注
     */
    CensusRemark.prototype.deleteKoseki = function (scope) {
        var _this = this;
        this.$confirm("您确定要删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(function () {
            _this.loading.state = true;
            _this.kosekiRemarkService
                .delete(scope.row, _this.loading)
                .subscribe(function (data) {
                _this.$message.success("操作成功");
                _this.refreshData();
            });
        }, function (err) {
            _this.$message.error(err.msg);
        })
            .catch(function () {
            _this.$message({
                type: "info",
                message: "已取消删除"
            });
        });
    };
    /**
     * 修改户籍弹框
     */
    CensusRemark.prototype.editKoseki = function (scope) {
        this.editModel = scope.row;
        this.dialog.edit = true;
    };
    /**
     * 查看户籍详情
     */
    CensusRemark.prototype.viewDetails = function (row) {
        this.rowData = row;
        this.dialog.remark = true;
    };
    CensusRemark.prototype.importBatchDeletion = function () {
        this.dialog.deletion = true;
    };
    __decorate([
        Dependencies(PageService)
    ], CensusRemark.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CensusRemark.prototype, "sortService", void 0);
    __decorate([
        Dependencies(KosekiRemarkService)
    ], CensusRemark.prototype, "kosekiRemarkService", void 0);
    __decorate([
        Dependencies(DataRepairImportService)
    ], CensusRemark.prototype, "dataRepairImportService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], CensusRemark.prototype, "uploadFileService", void 0);
    CensusRemark = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                AddRemark: AddRemark,
                EditRemark: EditRemark,
                RepairDataImport: RepairDataImport,
                CensusRemarkDetail: CensusRemarkDetail,
                ImportBatchDeletion: ImportBatchDeletion
            }
        })
    ], CensusRemark);
    return CensusRemark;
}(Vue));
export default CensusRemark;
